<template>
  <div id="app">
    <!-- 菜单导航 -->
    <Nav v-bind="{'type':'2','active':'4'}"/>
  
    <div class="header_bg">
      <img src="@/assets/index/notification_bg.png" alt="">
      通知公告
    </div>
    <!-- 翻页图文卡片组件 -->
    <div class="index-notification">
      <page-list v-bind="{'type':'3','active':'4'}" class="cardContent"></page-list>
    </div>
  
    <!-- 功能块 -->
    <FunctionBlock />
    <!-- 页脚 -->
    <Footer />
  </div>
</template>

<script>
import './index.scss'
import Nav from '@/components/newsComponents/NavMenu/index.vue'
import NewsList from '@/components/newsComponents/newsList/index.vue'
import NewsCardList from '@/components/newsComponents/newsCardList/index.vue'
import FunctionBlock from '@/components/newsComponents/functionBlock/index.vue'
import Footer from '@/components/newsComponents/footer/index.vue'
import newsBanner from '@/components/newsComponents/newsBanner/index.vue'
import PageList from '@/components/newsComponents/pageList/index.vue'
export default {
  name: 'App',
  components:{
    Nav,Footer,NewsList,NewsCardList,FunctionBlock,newsBanner, PageList
  },
  data(){
    return{
      newsData:[],
      checkForm:{
        status: '2',//已发布
        contentCategoryId: '154',//152-政策法规、153-行业新闻、154-通知公告
        companId: 0,
        indexFlag: "Y",
        pageNum: 1,
        pageSize: 10                                                                   
      },
    }
  },
  created(){
    this.getData();
    this.$api.visitLog({webServerType:0,pageName: '通知公告'})
  },
  methods:{
    getData:function(){
      this.$api.queryContentList(this.checkForm).then(res=>{
        console.log(res)
        if(res.data.resultCode==200){
          this.newsData = res.data.result;  
        }else{
          this.$message.error({ title: res.data.resultDesc });
        }      
      }).catch(err=>{
        console.log(err);
      })
    },
  }
}
</script>

